import { DealPriorityBadge } from '@/components/deal/priority/deal-priority-badge';
import type { Priority } from '@/models/types';
import PriorityFiltersComboBoxPopover from '../combobox-popovers/priority-filters-combobox-popover';
import type { PriorityFilterChipProps, PriorityFiltersState } from '../types';
import BaseFilterChip from './base-filter-chip';

const PriorityFilterChip = (props: PriorityFilterChipProps) => {
  const {
    filtersState,
    setFiltersState,
    deleteFilter,
    shouldDeleteWhenNoFiltersAreSelected,
  } = props;

  return (
    <BaseFilterChip<Priority, PriorityFiltersState>
      filtersState={filtersState}
      setFiltersState={setFiltersState}
      FiltersComboBoxPopover={PriorityFiltersComboBoxPopover}
      deleteFilter={deleteFilter}
      representativeIcon={<DealPriorityBadge value="high" hideCopy />}
      filterName="Priority"
      filterQuantifier={{ singular: 'priority', plural: 'priorities' }}
      SelectedFilterBadge={DealPriorityBadge}
      shouldDeleteWhenNoFiltersAreSelected={
        shouldDeleteWhenNoFiltersAreSelected
      }
      showBadgeOnlyWhenOneIsSelected
    />
  );
};

export default PriorityFilterChip;
